export default "__VITE_ASSET__CwIwxtgO__"